<template>
    <div class="bg-white p-6 shadow-md rounded-xl">
        <h2 class="text-lg font-semibold text-gray-700 mb-4 flex items-center">
            <span class="mr-2">💰</span>
            <span>Budget by Entity</span>
        </h2>
        <apexchart type="bar" height="300" :options="chartOptions" :series="chartSeries" />
    </div>
</template>

<script>
export default {
    name: "BudgetByEntityChart",
    props: {
        data: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        chartOptions() {
            return {
                chart: {
                    type: 'bar',
                    toolbar: { show: false },
                    events: {
                        dataPointSelection: (event, chartContext, config) => {
                            const selectedDataPoint = chartContext.w.config.series[0].data[config.dataPointIndex];
                            if (selectedDataPoint && selectedDataPoint.x) {
                                this.onEntityBarClick(selectedDataPoint.x);
                            }
                        },
                    },
                },
                xaxis: {
                    title: {
                        text: 'Budget Amount (AED)',
                        style: {
                            fontSize: '12px',
                            fontWeight: 'bold',
                        },
                    },
                },
                yaxis: {
                    title: {
                        text: 'Entity',
                        style: {
                            fontSize: '12px',
                            fontWeight: 'bold',
                        },
                    },
                },
                colors: this.getPowerBIColors(),
                plotOptions: {
                    bar: {
                        borderRadius: 0,
                        columnWidth: "60%",
                        distributed: true,
                        horizontal: true,
                    },
                },
                dataLabels: {
                    enabled: true,
                    formatter: (val) => {
                        return new Intl.NumberFormat('en-AE', {
                            style: 'currency',
                            currency: 'AED',
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0,
                        }).format(val);
                    },
                },
                tooltip: {
                    y: {
                        formatter: (val) => {
                            return new Intl.NumberFormat('en-AE', {
                                style: 'currency',
                                currency: 'AED',
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                            }).format(val);
                        },
                    },
                },
                legend: {
                    show: false
                }
            };
        },
        chartSeries() {
            return [
                {
                    name: "Budget",
                    data: this.data.map(item => ({
                        x: this.formatEntityName(item.entity),
                        y: item.budget
                    }))
                }
            ];
        }
    },
    methods: {
        onEntityBarClick(entity) {
            this.$emit('entity-clicked', this.unFormatEntityName(entity));
        },
        formatEntityName(entity) {
            return entity.replace(/ATHS/g, "ATS");
        },
        unFormatEntityName(entity) {
            return entity.replace(/ATS/g, "ATHS");
        },
        getPowerBIColors() {
            // Power BI inspired color palette
            return [
                '#1f77b4', // Blue
                '#ff7f0e', // Orange
                '#2ca02c', // Green
                '#d62728', // Red
                '#9467bd', // Purple
                '#8c564b', // Brown
                '#e377c2', // Pink
                '#7f7f7f', // Gray
                '#bcbd22', // Olive
                '#17becf', // Cyan
                '#aec7e8', // Light Blue
                '#ffbb78', // Light Orange
                '#98df8a', // Light Green
                '#ff9896', // Light Red
                '#c5b0d5', // Light Purple
                '#c49c94', // Light Brown
                '#f7b6d3', // Light Pink
                '#c7c7c7', // Light Gray
                '#dbdb8d', // Light Olive
                '#9edae5'  // Light Cyan
            ];
        }
    }
};
</script>
